module.exports = {
	"January": "Januar",
	"February": "Februar",
	"March": "Marts",
	"April": "April",
	"May": "Maj",
	"June": "Juni",
	"July": "Juli",
	"October": "Oktober",
	"August": "august",
	"September": "September",
	"November": "November",
	"December": "December",
	"weekday": {
		"short": {
			"monday": "Man",
			"tuesday": "Tir",
			"wednesday": "Ons",
			"thursday": "Tor",
			"friday": "Fre",
			"saturday": "Lør",
			"sunday": "Søn"
		}
	},
	"error": {
		"unknown": "Der skete desværre en ukendt fejl. Prøv igen eller henvend dig til support@testaviva.dk",
		"load": "Siden kunne ikke hentes fuldt ud, og der mangler derfor vigtige komponenter. Kontroller at du har forbindelse til internettet og prøv derefter at genindlæse siden. Hvis problemet fortsætter kan du kontakte support@testaviva.dk.",
		"form": {
			"email": "Den angivne e-mail adresse er i et ugyldigt format",
			"missingField": "Du skal udfylde dette felt",
			"cpr": "Det er fejl i det indtastede CPR nummer",
			"cprLength": "CPR nummer skal være 10 tal, uden bindestreger (XXXXXXXXXX)"
		}
	},
	"lifescore": {
		"menu": "Livsscore: {score}%",
		"updated": "Ved at oprette {product}, vil du øge din livsscore med {percentage}% til samlet {total}%.",
		"cta_create": "Opret",
		"cta_existing": "Jeg har allerede {product}",
		"cta_deny": "Jeg ønsker ikke {product}",
		"content_existing": "Du har valgt at du allerede har {product}. Dette betyder at du har oprettet {product} andetssteds end hos TestaViva, f.eks. hos en advokat.\n\nAt du allerede har {product}, betyder at du allerede har taget stilling til hvorvidt det er relevant for dig. Dette belønner TestaViva, og du vil derfor opnå samme livsscore procentpoint som hvis du oprettede {product} hos TestaViva.",
		"content_skip": "Du har valgt at du ikke ønsker {product}. Selvom TestaViva anbefaler dig {product}, vil dit fravalg have betydning for din livsscore.\n\nAt du ikke ønsker {product}, betyder at du nu tager stilling til hvorvidt det er relevant for dig. Dette belønner TestaViva, og du vil derfor opnå samme livsscore procentpoint som hvis du oprettede {product} hos TestaViva.\n\nDu kan altid ændre dit valg, ved at gå til Konto og vælge fanen Mine valg, hvor du kan føre et produkt tilbage til Livsguiden.",
		"cta_confirm_existing": "Jeg har allerede {product}",
		"cta_confirm_skip": "Jeg ønsker ikke {product}",
		"tooltip": "Tryk her for at læse om Livsscoren",
		"description": "Din livsscore fortæller hvor mange vigtige beslutninger TestaViva anbefaler du tager stilling til. For hver beslutning du tager, får du point og når du har 100 point, er du i mål."
	},
	"products": {
		"more": "Læs mere om {product}",
		"deed_property": {
			"title": "Skøde, Bolig",
			"singular": "Et boligskøde",
			"yours": "Dit boligskøde",
			"specific": "boligskødet",
			"multiple": "Boligskøder"
		},
		"will": {
			"title": "Testamente",
			"singular": "et testamente",
			"yours": "dit testamente",
			"specific": "testamentet",
			"multiple": "Testamenter"
		},
		"prenup": {
			"title": "Ægtepagt",
			"singular": "en ægtepagt",
			"yours": "din ægtepagt",
			"specific": "ægtepagten",
			"multiple": null
		},
		"beneficiary": {
			"title": "Begunstigelseserklæring",
			"singular": "en begunstigelseserklæring",
			"yours": "din begunstigelseserklæring",
			"specific": "begunstigelseserklæringen",
			"multiple": "Begunstigelseserklæringer"
		},
		"favored": {
			"title": "Begunstigelseserklæring",
			"singular": "en begunstigelseserklæring",
			"yours": "din begunstigelseserklæring",
			"specific": "begunstigelseserklæringen",
			"multiple": "Begunstigelseserklæringer"
		},
		"coop": {
			"title": "Samejekontrakt",
			"singular": "en samejekontrakt",
			"yours": "din samejekontrakt",
			"specific": "samejekontrakten",
			"multiple": "samejekontraker"
		},
		"future_pow": {
			"title": "Fremtidsfuldmagt",
			"singular": "en fremtidsfuldmagt",
			"yours": "din fremtidsfuldmagt",
			"specific": "fremtidsfuldmagten",
			"multiple": "fremtidsfuldmagter"
		},
		"undivided_estate_agreement": {
			"title": "Samtykkeerklæring",
			"singular": "en samtykkeerklæring",
			"yours": "din samtykkeerklæring",
			"specific": "samtykkeerklæringen",
			"multiple": "samtkkeerklæringer"
		},
		"values_database": {
			"title": "Mine Aktiver",
			"singular": "Mine Aktiver"
		},
		"will_contents": {
			"title": "Indbotestamente",
			"singular": "et indbotestamente",
			"yours": "dit indbotestamente",
			"specific": "indbotestamentet",
			"multiple": "indbotestamenter"
		},
		"inheritance_advance": {
			"title": "Arveforskud",
			"singular": "et arveforskud",
			"yours": "dit arveforskud",
			"specific": "arveforskudet",
			"multiple": "arveforskud"
		},
		"inheritance_waiver": {
			"title": "Arveafkaldet",
			"singular": "et arveafkald",
			"yours": "dit arveafkald",
			"specific": "arveafkaldet",
			"multiple": "arveafkald"
		},
		"deed_of_gift": {
			"title": "Gavebrev",
			"singular": "et gavebrev",
			"yours": "dit gavebrev",
			"specific": "gavebrevet",
			"multiple": "gavebrev"
		},
		"restricted_deed_of_gift": {
			"title": "Gavebrev med båndlæggelse",
			"singular": "et gavebrev med båndlæggelse",
			"yours": "dit gavebrev med båndlæggelse",
			"specific": "gavebrevet med båndlæggelse",
			"multiple": "gavebrev med båndlæggelse"
		},
		"promissory_note": {
			"title": "Gældsbrev",
			"singular": "et gældsbrev",
			"yours": "dit gældsbrev",
			"specific": "gældsbrevet",
			"multiple": "gældsbrev"
		},
		"pow": {
			"title": "Fuldmagt",
			"singular": "en fuldmagt",
			"yours": "din fuldmagt",
			"specific": "fuldmagten",
			"multiple": "fuldmagter"
		},
		"will_child": {
			"title": "Børnetestamente",
			"singular": "et børnetestamente",
			"yours": "dit børnetestamente",
			"specific": "børnetestamentet",
			"multiple": "børnetestamenter"
		},
		"togetherness_agreement": {
			"title": "Aftale om samvær",
			"singular": "en aftale om samvær",
			"yours": "din aftale om samvær",
			"specific": "aftalen om samvær",
			"multiple": "aftaler om samvær"
		},
		"child_support_agreement": {
			"title": "Aftale om forhøjet børnebidrag",
			"singular": "en aftale om forhøjet børnebidrag",
			"yours": "din aftale om forhøjet børnebidrag",
			"specific": "aftalen om forhøjet børnebidrag",
			"multiple": "aftaler om forhøjet børnebidrag"
		},
		"prenuptial_pension": {
			"title": "Pensionægtepagt",
			"singular": "en pensionægtepagt",
			"yours": "din pensionægtepagt",
			"specific": "pensionægtepagten",
			"multiple": "pensionsægtepagter"
		},
		"prenuptial_exit": {
			"title": "Ophævelse af særeje",
			"singular": "et ophævelse af særeje",
			"yours": "din ophævelse af særeje",
			"specific": "ophævelsen af særeje",
			"multiple": "ophævelser af særeje"
		},
		"deed_divorce": {
			"title": "Skøde, Skilsmisse",
			"singular": "et skilsmisseskøde",
			"yours": "dit skilsmisseskøde",
			"specific": "skilsmisseskødet",
			"multiple": "Skilsmisseskøder"
		},
		"property_division_agreement": {
			"title": "Bodelingsoverenskomst",
			"singular": "en bodelingsoverenskomst",
			"yours": "din bodelingsoverenskomst",
			"specific": "bodelingsoverenskomsten",
			"multiple": "Bodelingsoverenskomster"
		},
		"spousal_support_agreement": {
			"title": "Aftale om ægtefællebidrag",
			"singular": "en aftale om ægtefællebidrag",
			"yours": "din aftale om ægtefællebidrag",
			"specific": "aftalen om ægtefællebidrag",
			"multiple": "aftaler om ægtefællebidrag"
		},
		"buyer_advice": {
			"title": "Køberrådgivning",
			"singular": "en køberrådgivning",
			"yours": "din køberrådgivning",
			"specific": "Køberrådgivningen",
			"multiple": "køberrådgivninger"
		},
		"follow_up_processing": {
			"title": "Eftersagsbehandling",
			"singular": "en eftersagsbehandling",
			"yours": "din eftersagsbehandling",
			"specific": "Eftersagsbehandlingen",
			"multiple": "Eftersagsbehandlinger"
		},
		"rectification": {
			"title": "Berigtigelse",
			"singular": "en berigtigelse",
			"yours": "din berigtigelse",
			"specific": "Berigtigelsen",
			"multiple": "Berigtigelser"
		},
		"probate_certificate": {
			"title": "skifteretsattest",
			"singular": "en skifteretsattest",
			"yours": "din skifteretsattest",
			"specific": "Skifteretsattesten",
			"multiple": "Skifteretsattester"
		}
	},
	"lead": {
		"title": "Du kan desværre ikke færdiggøre dit dokument nu..",
		"submit": "Jeg vil gerne kontaktes af en jurist",
		"success": "Du vil blive kontaktet af en jurist indenfor 2 arbejdsdage"
	},
	"values": {
		"warning": "Du er ved at lukke vinduet. Hvis du lukker det, vil du miste alle det du har indtastet. Er du sikker på du vil lukke vinduet?",
		"inputValue": "<Indsæt værdi>",
		"create": "Opret værdi",
		"created": "Værdien er oprettet og kan findes i listen",
		"edited": "Dine ændringer er nu gemt",
		"type": "Type",
		"typeDescription": "Vælg typen på den værdi du vil oprette i listen herunder.",
		"name": "Navn",
		"nameDescription": "Indtast navnet eller en kort beskrivelse, på den værdi du er ved at oprette.",
		"total": "Samlet værdi:",
		"deleteHeadline": "Slet en værdi",
		"delete": "Dette vil slette {name} fra dine værdier.\n\nHvis du har delt værdien med andre, vil den også blive slettet fra deres værdier.\n\nEr du sikker?",
		"remove": "Dette vil fjerne {name}.\n\nDa du ikke har oprettet værdien, men fået den tildelt, vil du ikke slettet værdien, blot fjerne den fra dine værdier.\n\n Er du sikker?",
		"deleteError": "Vi kunne ikke slette værdien. Prøv at opdatere siden, og slet værdien igen.\nHvis fejl stadig opstår, kontakt venligst support@testaviva.dk",
		"shareHeadline": "Del værdier",
		"share": "Del de værdier du har valgt med en anden person, som f.eks. være din ægtefælle. Det kan være en god ide, hvis i har formuefællesskab.\n\nIndtast e-mail adressen på den person du ønsker at dele dine værdier med herunder, så sender vi en notifikation til brugeren. Hvis personen med e-mail adressen ikkke allerede er oprette på TestaViva, opretter vi samtidig en ny bruger til denne.",
		"shareDone": "En anmodning om at dele værdier er sendt",
		"sharedWith": "Delt med: ",
		"sharedBy": "Delt af: ",
		"shareMark": "Del",
		"shareMarked": "Del valgte",
		"shareErrorSelf": "Du kan ikke dele værdier med dig selv",
		"download": "Hent som PDF",
		"imageHeadline": "Billede",
		"image": "Billeder",
		"imageDescription": "Det er altid en god ide at uploade et billede af den værdi, du er ved at oprette. Det kan ofte være en stor hjælp i f.eks. forsikringssager.",
		"imageError": "Det billede du har valgt, er af forkert type. Du kan kun uploade billeder af JPG, PNG eller GIF format.",
		"imageDelete": "Tryk her for at slette dette billede",
		"cadastral": "Matrikelnummer",
		"cadastralDescription": "Matrikelnummeret på din ejendom kan du finde på https://www.ois.dk.",
		"value": "Værdi: ",
		"valueDescription": "Indtast værdien i kroner, der bedst afspejler den aktuelle værdi. Bemærk du kan kun indtaste tal i dette felt.",
		"documentationHeadline": "Vedhæft dokumentation",
		"documentationDescription": "Vedhæft dokumentation for værdien. Dette kan f.eks. være købsbevis, garantibevies eller lignende.",
		"documentationExisting": "Eksisterende dokumentation",
		"documentationExistingDescription": "Her finder du dokumentation du tidligere har tilføjet til værdien.",
		"documentationExistingDelete": "Tryk her for at slette dokumentationen",
		"types": {
			"value": {
				"title": "Indbo",
				"description": "Møbler, smykker el.lign.",
				"quantity": "Antal stk",
				"quantityDescription": "Hvis den værdi du opretter, indeholder flere stk, kan du her angive hvor mange"
			},
			"property": "Ejendom",
			"vehicle": "Køretøj",
			"vessel": "Båd",
			"saving": "Opsparing",
			"insurance": "Livsforsikring",
			"company": "Firma",
			"pension": "Pension"
		},
		"addressType": {
			"title": "Ejendoms type",
			"description": "Angiv her hvilken type ejendom du ejer",
			"share": "Andel",
			"owner": "Ejerbolig",
			"ownerAbroad": "Ejerbolig i udlandet",
			"business": "Erhvervsejendom",
			"houseBoat": "Husbåd",
			"allotment": "Kolonihave",
			"agriculture": "Landbrugsejendom",
			"cottage": "Sommerhus"
		},
		"vehicle": {
			"vin": "Stelnummer",
			"vinDescription": "Angiv her det fulde stelnummer på køretøjet. Det er vigtigt du angiver det fuldstændige, korrekte stelnummer",
			"registrationNumber": "Registreringsnummer",
			"registrationNumberDescription": "Angiv her registreringsnummeret på køretøjet om det fremgår på registreringsattesten",
			"brand": "Mærke",
			"brandDescription": "Angiv mærket på køretøjet, fx Volkwagen",
			"model": "Model",
			"modelDescription": "Angiv modellen på køretøjet, fx Golf III",
			"vehicleType": {
				"title": "Køretøj type",
				"description": "Angiv her om du er ved at oprette en bil eller en motorcykel",
				"car": "Bil",
				"bike": "Motorcykel"
			}
		},
		"vessel": {
			"vesselType": {
				"title": "Bådtype",
				"description": "Vælg her om det er en motorbåd eller en sejlbåd",
				"motor": "Motorbåd",
				"sail": "Sejlbåd"
			},
			"brand": "Mærke",
			"brandDescription": "Angiv her mærket af båden, f.eks. Sea Ray",
			"model": "Model",
			"modelDescription": "Angiv her modellen af båden, f.eks. 325",
			"year": "Årgang",
			"yearDescription": "Angiv det år, båden er produceret, f.eks. 1985"
		},
		"saving": {
			"savingType": {
				"title": "Opsparingstype",
				"description": "Vælg om opsparing er en i banken eller en din pensionsopsparing",
				"pension": "Pension",
				"bank": "Bank",
				"stocks": "Aktier"
			},
			"company": "Selskab",
			"companyDescription": "Angiv navnet på det selskab du har opsparing stående i, fx PensionDanmark",
			"number": "Police el. kontonummer",
			"numberDescription": "Angiv kontonummeret på den konto din opsparing står på, hvis det er en bank opsparing, eller det fulde policenummer på din pensionsopsparing"
		},
		"insurance": {
			"company": "Selskab",
			"companyDescription": "Angiv det fulde selskabsnavn på forsikringsselskabet",
			"number": "Police nummer",
			"numberDescription": "Angiv policenummeret på din forsikring"
		},
		"company": {
			"cvr": "CVR",
			"cvrDescription": "Angiv det fulde CVR nummer. Du kan finde det på www.cvr.dk",
			"number": "P-nummer",
			"numberDescription": "Angiv P nummeret på enheden. Du kan finde det på www.cvr.dk"
		}
	},
	"user": {
		"undo": "Fortryd",
		"cancel": "Annuller",
		"login": "Log ind",
		"delete": "Slet bruger",
		"deleteContent": "Dette vil slette din bruger og den information vi opbevarer omkring dig.\n\nHvis du har tilkøbt adgang til produkter på platformen, vil disse abonnementer stoppe og du vil ikke længere have adgang til dem.\n\nBemærk du vil ikke få refunderet eventuelle produkter der endnu ikke er udløbet.",
		"createFail": "Kunne ikke oprette en bruger. Prøv igen eller kontakt support@testaviva.dk.",
		"authenticateFail": "Kunne ikke logge ind. Har du angivet den rigtig e-mail adresse og kodeord?"
	},
	"misc": {
		"none": "Ingen",
		"filter": "Filtrer",
		"all": "Alle",
		"email": "E-mail",
		"confirm": "Bekræft",
		"error": "Beklager, men der skete en fejl. Prøv venligst igen, eller kontakt support@testaviva.dk.",
		"address": "Adresse",
		"addressDescription": "Indtast gade, nummer samt yderligere detaljer på adressen, f.eks. Hollændervej 17, 2th",
		"zip": "Postnummer",
		"city": "By",
		"country": "Land",
		"save": "Gem",
		"currency": "DKK",
		"next": "Næste",
		"previous": "Forrige",
		"openAndStartVideo": "Åbn og start video",
		"back": "Tilbage",
		"yes": "Ja",
		"no": "Nej",
		"show": "Vis",
		"free": "Gratis",
		"choose": "Vælg"
	},
	"notifications": {
		"accept": "Godkend",
		"refuse": "Afvis",
		"goToAll": "Se alle notifikationer",
		"empty": "Ingen notifikationer",
		"accepted": "Du godkendte",
		"refused": "Du afviste"
	},
	"countries": {
		"dk": "Danmark"
	},
	"onboarding": {
		"read_more": "Læs mere",
		"create": "Opret",
		"icons": {
			"kids": "Børn",
			"death": "Død",
			"partner": "Partner",
			"pension": "Pension",
			"disease": "Sygdom",
			"accident": "Ulykke",
			"values": "Værdier",
			"residential": "Bolig",
			"you": "Dig selv",
			"divorce": "Skilsmisse",
			"spouse": "Ægtefælle",
			"savings": "Opsparing"
		},
		"steps": {
			"information": "Start",
			"personal": "Personlig profil",
			"marital_status": "Civil status",
			"assets": "Værdier",
			"documents": "Dokumenter",
			"onboard": "Livsscore"
		},
		"information": {
			"title": "Velkommen",
			"description": "Testen tager kun 2 minutter, og du får:",
			"item1": "Gratis medlemsskab af TestaViva",
			"item3": "Overblik over dine aftaler og værdier",
			"item4": "Personlige råd og forslag til opdatering af dine juridiske dokumenter"
		},
		"finishButton": "Kom igang nu",
		"clock": {
			"time": "2 min",
			"text": "Testen tager kun"
		},
		"personal": {
			"title": "Hvordan vil du bruge TestaViva?",
			"meTitle": "Mig",
			"partnerTitle": "Partner",
			"alone": "Kun mig",
			"partner": "Min partner og jeg",
			"alonePage": "Dine informationer",
			"partnerPage": "Jeres informationer"
		},
		"marital": {
			"question": "Vælg her om i er gift",
			"title": {
				"alone": "Vælg din civilstand",
				"partner": "Er I gift?"
			}
		},
		"marriagePlanned": "Overvejer I at blive gift snart?",
		"hasChildren": {
			"alone": {
				"title": "Har du børn?",
				"description": "Vælg her om du har børn"
			},
			"partner": {
				"title": "Har i børn?",
				"description": "Vælg her om i har børn"
			}
		},
		"livingTogether": "Lever I sammen, eller overvejer I at leve sammen?",
		"realEstates": {
			"title": "Ejendomme",
			"description": {
				"alone": "Vælg hvilke typer af ejendomme du ejer",
				"partner": "Vælg hvilke typer af ejendomme I ejer"
			}
		},
		"assets": {
			"alone": {
				"title": "Værdier",
				"description": "Hvor ligger din formue gemt?"
			},
			"partner": {
				"title": "Værdier",
				"description": "Hvor ligger jeres formue gemt?"
			}
		},
		"final": {
			"fullname": "{first} {last}",
			"title": "Test resultat",
			"sub_title": "Ting og personer du nemt kan sikre",
			"list_title": "Vi har oplistet i prioriteret rækkefølge",
			"list_sub_title": "På baggrund af dine svar, har vi nedenfor oplistet de juridiske dokumenter du med fordel kan oprette for at sikre dig selv og alle de ting, som ellers er vigtige for dig",
			"termsText": "regler og betingelser"
		},
		"form": {
			"email": "E-mail",
			"phone": "Telefon",
			"firstName": "Fornavn",
			"lastName": "Efternavn",
			"password": "Kodeord",
			"passwordRepeat": "Gentag kodeord",
			"passwordSent": "Kodeordet vil blive tilsendt",
			"passwordHelp": "Dit kodeord skal være på minimum 6 tegn og indeholde minimum et tal og et bogstav.",
			"age": "Alder",
			"gender": "Køn",
			"genderOptions": {
				"male": "Mand",
				"female": "Kvinde"
			},
			"maritalStatus": "Civilstatus",
			"maritalOptions": {
				"married": "Gift",
				"partnership": "I forhold",
				"registered_partnership": "Registreret partnerskab",
				"single": "Single"
			},
			"yesNoOptions": {
				"yes": "Ja",
				"no": "Nej"
			},
			"assets": "Værdier",
			"assetsOptions": {
				"realEstate": {
					"title": "Bolig",
					"description": "Ejer- eller andelsbolig, sommerhus eller kolonihave"
				},
				"vehicle": {
					"title": "Fartøjer",
					"description": "Bil, motorcykel, båd etc."
				},
				"contents": {
					"title": "Indbo",
					"description": "Genstande med høj økonomisk værdi eller affektionsværdi"
				},
				"savings": {
					"title": "Opsparing",
					"description": "Opsparing i banken og/eller en pensionsopsparing"
				}
			},
			"realEstates": "Ejendomme",
			"realEstatesOptions": {
				"cooperative": "Andelslejlighed",
				"ownerOccupied": "Ejerbolig",
				"allotment": "Kolonihave",
				"cottage": "Sommerhus"
			}
		}
	},
	"partners": {
		"title": "Medlemsfordele",
		"description": "Hvis du er kunde eller medlem hos en af de virksomheder, som er oplistet nedenfor, har du hvert år adgang til juridisk rådgivning. Du skal bare klikke på de virksomheder, du er kunde hos eller medlem af. Herefter kan du gøre brug af juridisk rådgivning hos TestaVivas jurister.",
		"save": "Gem valgte",
		"edit": "Rediger medlemsfordele",
		"none": "Jeg er ikke kunde i eller medlem af nogle af de oplistede organisationer.",
		"error": "Du skal give samtykke",
		"errorSave": "Vi kunne ikke gemme dine valg af medlemsfordele. Du kan prøve igen ved at vælge dem under \"Min profil\", eller henvende dig til info@testavia.dk hvis problemet fortsætter.",
		"errorSaveOnboardingPartner": "Du kan ikke fjerne den partner du er henvist igennem.",
		"success": "Dine medlemsfordele er gemt",
		"package": {
			"selected": "Valgt som en del af pakken",
			"title": "Vælg {numberOfDocuments} dokumenter og få en god pris",
			"text_default": "Du får {numberOfDocuments} juridiske dokumenter til én samlet pris, og du betaler samlet for alle dokumenter. Vælg enten alle dokumenter med det samme, eller start med at vælge et nu og vælg resten på et senere tidspunkt.",
			"text_in_progress": "Du er i gang med at oprette dine {numberOfDocuments} juridiske dokumenter. Du kan her se en status på de dokumenter du har valgt.",
			"text_available": " Du mangler at vælge 1 dokument. Vælg det dokument du ønsker herunder og tryk på Vælg og fortsæt knappen.",
			"text_available_multiple": "Du mangler at vælge {availableSelections} dokumenter. Vælg de dokumenter du ønsker herunder og tryk på Vælg og fortsæt knappen.",
			"text_none_available": " Du kan ikke vælge flere dokumenter. Færdiggør dine dokumenter ved at trykke på dem herunder.",
			"text_wrong_selection": "Har du valgt et forkert dokument? Kontakt vores support, så kan vi ændre dine valg.",
			"text_document": " Du er nu færdig med {document} og kan vælge om det skal være en del af din pakke. Tryk på knappen fortsæt for at bekræfte, at det skal være en del af pakken.",
			"error": "Du skal vælge minimum 1 dokumenter",
			"recommendations": "TestaViva anbefaler du opretter",
			"other": "Andre relevante",
			"buy": "Køb og fortsæt",
			"continue": "Fortsæt",
			"continue_product": "Fortsæt med valgte dokumenter",
			"confirm": "Vælg og fortsæt",
			"cancel": "Fortryd",
			"product": {
				"title": "{product} er valgt som ét af dine to produkter",
				"products": {
					"future_pow": "Du har nu valgt en fremtidsfuldmagt, som er et juridisk dokument, som TestaViva mener, at alle danskere over 18 år bør få lavet – du er allerede godt på vej.\n\nTestaViva har aftalt med Jutlander Bank, at man som kunde hos Jutlander Bank i hver husstand kan oprette to fremtidsfuldmagter, som prismæssigt kun vil blive betragtet som et dokument. Hvis I ønsker at benytte det tilbud, skal I blot udfylde fremtidsfuldmagten for den bruger, I er logget ind med. Når I efterfølgende har telefonmøde med en af TestaVivas jurister, laver juristen fremtidsfuldmagten for den anden partner i husstanden.\n\nSom en del af dit tilbud hjælper TestaViva dig igennem hele processen og sørge for, at du får en juridisk gyldig fremtidsfuldmagt efter dine ønsker. TestaViva sørger skridt for skridt for, at du bliver hjulpet og sikrer, at dokumentet opfylder alle de krav, der er til denne type juridiske dokument.\n\nNår dokumentet er oprettet på TestaViva.dk, tinglyser TestaViva dokumentet for dig. Derefter skal du selv møde fysisk op ved retten, hvor du skal vedkende den tinglyste fremtidsfuldmagt – der vil være en retsafgift på kr. 300 pr. fuldmagt, som betales direkte til notaren.\n",
					"will": "Du har nu valgt et testamente, som er et juridisk dokument, som TestaViva mener, de fleste danskere bør få lavet (også selv om man er gift) – du er allerede godt på vej.\n\nSom en del af dit tilbud vil TestaViva hjælpe dig igennem hele processen og sørge for, at du får et juridisk gyldigt testamente efter dine ønsker. TestaViva sørger skridt for skridt for, at du bliver hjulpet og sikrer, at dokumentet opfylder alle de krav, der er til denne type juridiske dokument.\n\nNår dokumentet er oprettet på TestaViva.dk og gennemgået med en juridisk rådgiver, skal du underskrive testamentet sammen med en eventuel medopretter og to vidner. Du kan i stedet for vidner vælge at underskrive testamentet ved retten foran en notar – der vil være en retsafgift på kr. 300, som betales direkte til notaren.\n",
					"favored": "Du har valgt at lave en begunstigelseserklæring. Det er et vigtigt dokument at tage stilling til og få lavet, så du selv kan bestemme, hvem der skal begunstiges på dine pension(er) og evt. livsforsikringer. Ved at lave en begunstigelseserklæring gennem TestaViva får du også muligheden for at give dine begunstigede særeje på den formue de evt. en dag modtager fra dig. Det betyder, at den formue, de modtager, ikke skal deles med andre.\n\nSom en del af dit tilbud hjælper TestaViva dig igennem hele processen og sørger for, at du får en juridisk gyldig begunstigelseserklæring efter dine ønsker. TestaViva sørger skridt for skridt for, at du bliver hjulpet og sikrer, at dokumentet opfylder alle de krav, som der er til denne type juridiske dokument. Dette inkluderer bl.a., at TestaViva sender begunstigelseserklæringen ind til dit pensionsselskab eller forsikringsselskab. TestaViva vil desuden stå for det arbejde, der skal til, for at dit selskab vedkender, at dine ønsker bliver registeret på dine ordninger og policer. TestaViva tager ikke betaling for det ekstra arbejde, da vores formål er at gøre det så nemt og økonomisk tilgængeligt for dig som overhovedet muligt. Når alt er på plads, vil TestaViva orientere dig om, at erklæringen er accepteret og dermed vedkendt.\n",
					"prenup": "I har valgt at lave en ægtepagt. Det er et dokument, mange med fordel kan oprette, inden man bliver gift eller under ægteskabet. En ægtepagt giver nogle fordele ved, at man kan lave særeje på dele eller hele formuen. Det betyder, at ægtepagten kan beskytte ens ægtefælle, og den kan beskytte den person som har formue, ved at personen ikke skal dele formuen ved en evt. skilsmisse.\n\nSom en del af dit tilbud vil TestaViva tinglyse ægtepagten, når dokumentet er færdigt, og det er blevet gennemgået sammen med en af vores jurister. TestaViva tager ikke betaling for arbejdet med at tinglyse ægtepagten, men der vil være en tinglysningsafgift på 1750 kr. + evt. betalingsgebyr. Dette skal I betale til TestaViva, før vi kan starte processen, da vi bliver opkrævet beløbet som afgift, når vi gennemfører selve tinglysningen.\n",
					"coop": "I har valgt at lave en samejekontrakt på den bolig, I ejer sammen. Det er en rigtig god idé, da penge ofte kan medføre splid i venskaber og partnerskaber. Denne kontrakt er en af de vigtige aftaler, I laver sammen. I får nemlig en klar aftale, om hvad der skal ske med de penge, I hver især kommer med til boligen (fx penge fra et lån, fra en gave, fra en arv eller andet). I får bl.a. besluttet, hvad der skal ske, hvis der skal laves en stor reparation af en skade, eller der er ønske om renovering. Og endelig får I skrevet ned, hvad skal der ske, hvis I en dag skal sælge boligen, fordi I skal flytte i ny bolig eller beslutter, at I ikke længere skal bo sammen eller eje boligen sammen længere.\n\nHvis I er gift, er der lovregler, der kan hjælpe til afklaring af, hvem der skal have jeres fælles bolig, hvis I går fra hinanden. Er I gift anbefaler vi derfor, at I ringer til TestaViva, inden I laver dokumentet færdigt, da der er nogle emner, som er relevante for jer at kende til – og for at sikre om samejekontrakten er det rette aftaledokument for jer.\n\nSom en del af jeres tilbud vil TestaViva hjælpe jer igennem hele processen og sørge for, at I får udformet en juridisk gyldig samejekontrakt efter jeres ønske. TestaViva sørger skridt for skridt for, at I bliver hjulpet og sikrer, at dokumentet opfylder alle de krav, der er til denne type juridiske dokument.\n",
					"undivided_estate_agreement": "I har valgt at lave en samtykkeerklæring til uskiftet bo. Det er en erklæring, som gives fra et særbarn (bonusbarn) til en “bonus forælder”. I samtykkeerklæringen giver særbarnet samtykke til, at dets forælders ægtefælle kan sidde i uskiftet bo, hvis barnets forælder skulle dø før bonusforælderen. TestaViva anbefaler, at I laver et testamente i forbindelse med at samtykkeerklæringen til uskiftet bo bliver oprettet. Dette anbefales, da forældre ofte vælger at begunstige særbarnet i et testamente, for at særbarnet accepterer, at udbetalingen af dennes arv først vil ske den dag bonusforælderen vælger at skifte boet eller går bort.\n\nSom en del af jeres tilbud hjælper TestaViva jer igennem hele processen og sørge for, at I får udformet en juridisk gyldig samtykkeerklæringen efter jeres ønske. TestaViva sørger skridt for skridt for, at I bliver hjulpet og sikrer, at dokumentet opfylder alle de krav, der er til denne type juridiske dokument.\n"
				},
				"confirm": "Ok, det er forstået",
				"start": "Ok, start {product}"
			},
			"modal": {
				"title": "Du skal kun vælge {amount} dokumenter",
				"content0": "Du har valgt {amount} dokumenter, du skal derfor nu bare trykke på knappen \"Køb og fortsæt\".",
				"content1": "Hvis du gerne vil ændre et af de dokumenter du har valgt til {singular}, kan du gøre det ved at fravælge et af de valgte dokumenter, blot ved at klikke på det. Hvis du har betalt og ønsker at ændre dine valg, skal du ringe til os på 88626050 eller skrive på support@testaviva.dk.",
				"content2": "Når du har oprettet de {amount} dokumenter du ønsker, vil du herefter kunne købe flere produkter til meget favorable priser. Du kan allerede nu starte på at oprette andre dokumenter længere nede på siden. Det koster ikke noget at gå i gang og du får en fornemmelse af de enkelte produkter.",
				"cta": "OK, jeg forstår"
			}
		}
	},
	"signature": {
		"creator": "Underskriver",
		"witness": "Vidne",
		"name": "Navn",
		"complete": "Udfyld",
		"location": "Sted for underskrift",
		"location_description": "Her indtastet stedet hvorfra I underskriver digitalt",
		"ssn": "CPR-nummer",
		"ssn_help": "Skriv dit CPR-nummer uden bindestreg",
		"ssn_title": "Sikker oplysning af CPR-nummer til digital underskrift med NemID",
		"ssn_description": "CPR-nummeret bliver ikke gemt efterfølgende, men er nødvendigt for at underskrive med NemID.",
		"submit": "Gå til underskrift"
	},
	"documents": {
		"actions": {
			"edit": "Rediger dokument",
			"confirm": "Bekræft nu",
			"sign": "Underskriv nu",
			"sign_ses": "Underskriv med NemID",
			"upload": "Upload",
			"register": "Gå til tinglysning",
			"payment": "Køb dette dokument",
			"waiting_for_payment": "Betal for din ordre"
		},
		"confirm": {
			"title": "Bekræft",
			"proceed": "Bekræft",
			"cancel": "Annuller"
		},
		"delete": {
			"title": "Slet dokument",
			"content": "Du er ved at slette {document}. Denne handling kan ikke fortrydes, så det er vigtigt at du er helt sikker på at det er det rigtige dokument, du er ved at slette. Du bedes skrive navnet på det dokument du er ved at slette nedenfor.",
			"input": "Skriv \"{document}\" for at slette dokumentet",
			"proceed": "Slet mit dokument",
			"cancel": "Annuller",
			"error": "Kunne ikke slette dokumentet. Prøv venligst igen"
		},
		"upload": {
			"extrenal_title": "Tilføj eksisterende dokument",
			"title": "Upload dokument",
			"selectorTitle": "Vælg dokument type",
			"default_option": "Vælg type dit dokument er",
			"extern_content": "Du kan her uploade et dokument du har lavet et andet sted end TestaViva. Har du f.eks. et eksisterende testamente liggende, og du ønsker at TestaViva skal passe på det for dig, kan du nemt lægge det op her.",
			"content": "Du kan her uploade dit dokument til TestaViva, så passer vi godt på det for dig.\nVed at opbevare dine juridiske dokumenter hos TestaViva, er du sikker på at de altid bliver udleveret til den eller de rette instanser, når der er brug for dem.",
			"notice": "Bemærk at dit dokument skal være i PDF format og det må maksimalt fylde 20mb.",
			"button": "Upload",
			"error": {
				"noOption": "Du mangler at vælge hvilken type dit dokument er.",
				"fileempty": "Du skal vælge et PDF dokument",
				"filetype": "Forkert filtype. Du kan kun uploade PDF dokumenter",
				"filesize": "Filen du prøver at uploade er for stor. Filen må maksimalt fylde 20mb",
				"unknown": "Vi kunne ikke gemme filen. Prøv igen senere, eller kontakt support@testaviva.dk"
			}
		}
	},
	"booking": {
		"confirmation": {
			"title": "Tillykke, du skal ikke gøre mere, før vi ringer dig op",
			"description": "Godt gået! Du mangler nu bare, at få juridisk rådgivning. Vi har sendt en mail som bekræfter mødetidspunkt. Det\ner vigtigt at du læser mailen inden mødet, da vi har samlet alle vores erfaringer sammen og beskrevet hvad du\nskal gøre inden mødet. Ved at du læser mailen, skabes der et bedre grundlag, for et rigtig godt møde.\n",
			"cta": "Ok, jeg læser mailen grundigt"
		}
	},
	"product": {
		"login_to_buy": "For at gennemføre købet skal du enten logge ind, eller oprette en bruger.",
		"diy": "Selvbetjening",
		"create": "Kom i gang nu",
		"requiredEmail": "Du skal indtaste en e-mail adresse",
		"requiredPassword": "Du skal indtaste et kodeord",
		"requiredName": "Du skal angive et navn",
		"requiredPasswordEquality": "Kodeord og gentag kodeord skal være ens",
		"requiredPasswordStrength": "Dit kodeord skal være på minimum 6 tegn og indeholde minimum et tal og et bogstav.",
		"userCreateSuccess": "Du har nu oprettet en bruger på TestaViva. En velkomst mail er sendt afsted til dig!",
		"partner": "Rådgivning gratis for kunder i AL og LO medlemmer",
		"readMore": "Klik for at læse mere om {title}",
		"diyTitle": "Selvbetjening",
		"diyPrice": "GRATIS",
		"legalAdvice": "Juridisk rådgivning",
		"currency": "DKK",
		"purchase": "Køb nu",
		"more": "Læs mere.",
		"purchaseModalTitle": "Køb af juridisk rådgivning til {name}",
		"purchaseModalAuthenticate": "Inden du kan købe juridisk rådgivning, skal du logge ind.<br /><br /> Hvis du <strong>ikke</strong> allerede har en bruger hos TestaViva, kan du nemt oprette en.<br /><br /> Du skal blot trykke på knappen <strong>Opret en gratis bruger</strong> - det er som sagt helt gratis.",
		"purchaseModalCardSetup": "Du er ved at købe juridisk rådgivning til {name} for {price} DKK.<br /><br /> Da du endnu ikke har lavet nogle køb hos TestaViva, skal vi have opsat et betalingskort - det er nemt og det tager kun et par minutter.<br /><br /> Vi benytter QuickPay til at håndtere alle vores transaktioner, hvilket betyder TestaViva ikke gemmer informationer om dit kort - det sørger QuickPay for at opbevare trygt og godt.<br /><br /> Du kan finde vores handelsbetingelser <a href=\"https://testaviva.dk/almindelige-salgs-og-leveringsbetingelser-for-testaviva-dk\" target=\"_blank\">her</a>.<br /><br /> Tryk på knappen herunder for at bekræfte, opsætte et betalingskort og gennemføre købet.",
		"purchaseConditions": "Du er ved at købe juridisk rådgivning til {name} for {price} DKK.<br /><br /> Du kan finde vores handelsbetingelser <a href=\"https://testaviva.dk/almindelige-salgs-og-leveringsbetingelser-for-testaviva-dk\" target=\"_blank\">her</a><br /><br /> Tryk på knappen herunder for at bekræfte og gennemføre købet.",
		"formName": "Navn",
		"formEmail": "E-mail",
		"formPassword": "Kodeord",
		"formPasswordRepeat": "Gentag kodeord",
		"formPasswordHelp": "Dit kodeord skal være på minimum 6 tegn og indeholde minimum et tal og et bogstav.",
		"formButtonLogin": "Log ind",
		"formOr": "eller",
		"formButtonCreate": "Opret en gratis bruger",
		"formConfirm": "Bekræft"
	},
	"eidModal": {
		"title": "Log ind med NemID eller MitID",
		"content": "For at sikre dig og dit data så godt som muligt, skal du logge ind med <b>NemID</b> eller <b>MitID</b>. <br /> <br /> Vælg en af nedenstående muligheder"
	},
	"login": {
		"loginLink": "START HER",
		"loginForm": {
			"email": "Din e-mail",
			"password": "Kodeord",
			"loginButton": "Log ind",
			"facebookButton": "Fortsæt med Facebook",
			"googleButton": "Fortsæt med Google",
			"external_no_email_error": "Vi modtog ikke en email fra {name}, og kunne derfor ikke logge dig ind. Skulle dette være en fejl, kontakt TestaViva på support@testaviva.dk.",
			"forgotPasswordButton": "Har du glemt dit kodeord?",
			"takeTestButton": "Tag testen",
			"takeTestText": "Ved at tage testen opretter du både en bruger på TestaViva og vi kan rådgive dig til at oprette de dokumenter der er vigtige for dig. Det er nemt og tager kun 2 minutter.",
			"newUserButton": "Opret bruger",
			"strikeText": "ELLER",
			"error": "Ugyldige loginoplysninger.",
			"externalError": "Der skete en fejl med {name} login. Kontankt TestaViva på support@testaviva.dk, hvis denne fejl fortsætter",
			"apiError": "Kunne ikke logge dig ind med Facebook. Prøv at genindlæse siden og prøv igen.",
			"required": "Udfyld alle felterne for at logge ind."
		}
	},
	"deleteUserModal": {
		"feedback": {
			"title": "Kære {firstName} vi er kede af, at du forlader os",
			"subTitle": "Er du ikke sød at give os feedback på, hvorfor du ønsker at lukke din konto?",
			"option1": "Jeg har en dubletkonto",
			"option2": "Jeg modtager for mange e-mails",
			"description2": "Vidste du, at du kan vælge hvilke e-mails, du vil modtage fra TestaViva? Besøg din <strong>Konto</strong> og angiv dine præferencer under <strong>Mine tilladelser</strong>.",
			"option3": "Jeg er bekymret over beskyttelsen af mine personlige oplysninger",
			"description3": "Vidste du, at alle dokumenter hos TestaViva, ligegyldigt hvor i processen de er, gemmes på sikre og krypterede servere hos Microsoft? Den eneste, der har adgang til dokumenterne, er den enkelte TestaViva-bruger.",
			"option4": "Jeg har fået de dokumenter, jeg har brug for",
			"description4": "Vidste du, at det er gratis at opbevare sine dokumenter hos TestaViva, og at de alle gemmes på sikre og krypterede servere hos KMD og Microsoft?",
			"option5": "Andet",
			"checkbox": "Jeg er indforstået med at TestaViva sletter alle mine dokumenter",
			"noChoiceSelected": "Vælg en af mulighederne tak.",
			"deleteFailed": "Der skete desværre en fejl og vi kunne ikke slette dine oplysninger. Prøv igen eller kontakt support@testaviva.dk.",
			"notGivenConsent": "Du skal acceptere at Testaviva sletter dine dokumenter, for at vi kan slette din bruger.",
			"textfield": "Tekstfelt må ikke være tomt"
		}
	},
	"createUserModal": {
		"name": "Dit navn",
		"phone": "Dit telefonnummer",
		"mail": "Din e-mail adresse",
		"password": "Kodeord",
		"repeatPassword": "Gentag kodeord",
		"termsAndCondition": "regler og betingelser",
		"marketing": "Jeg ønsker at modtage nyheder og tilbud fra TestaViva",
		"passwordHelperText": "Din adgangskode skal være på min. 6 tegn og indeholde min. ét tal og ét bogstav",
		"loginText": "Log ind her",
		"createUserButton": "Opret bruger",
		"error": {
			"confirmPasswordError": "Dine kodeord matcher ikke",
			"missingField": "Du skal udfylde dette felt"
		}
	},
	"products_overview": {
		"title": "Produkter",
		"description": "Her finder du en liste af alle de produkter og services, der tilbydes på TestaViva.",
		"search": "Søg",
		"buttons": {
			"all": "Alle",
			"marriage": "Parforhold",
			"hers": "Arv & Gaver",
			"house": "Bolig & Fremtid"
		},
		"products": {
			"diy": "Selvbetjening",
			"new": "Opret nyt",
			"review": "Juridisk tjek",
			"diyAdvice": "Selvbetjening + Rådgivning",
			"advice": "Rådgivning",
			"create_button_price": "Opret {price}",
			"payNowOrLater": "Ønsker du at betale nu, eller når <br /> du har udfyldt dit dokument?",
			"payNow": "Betal nu",
			"payLater": "Betal senere",
			"create_button": "Opret",
			"continue": "Fortsæt",
			"edit": "Rediger dokument"
		}
	},
	"product_not_implemented": {
		"title": "Vi er der næsten",
		"topContent": "Vi arbejder på at digitalisere alle juridiske dokumenter, men vi må indrømme at vi endnu ikke har gjort dette dokument digitalt.",
		"cta": "Giv mig besked når {product} er digitaliseret",
		"botContent": "Hvis du ikke kan vente, kan du altid ringe til vores venlige jurister på <a href=\"tel:88626050\">88 62 60 50</a> - så kan de oprette det for dig manuelt. <br />Du kan finde priserne på vores ikke-digitale produkter <a href=\"https://testaviva.dk/priser\">her</a>. Vi har altid markedets laveste priser, og det har vi prisgaranti på. <br /><br />"
	},
	"30_rule_widget": {
		"title": "Støt velgørenhed, og giv dine arvinger flere penge",
		"sub_title": "Minimér arveafgift ved brug af 30%-reglen. Fordelagtig for dig, der ikke har direkte arvinger* og ønsker dine søskende, nevøer/niecer eller venner som arvinger.",
		"subsub_title": "Tjek nedenfor, hvad reglen kan betyde for den gode sag og dine arvinger.",
		"direct_heirs": "*Direkte arvinger er forældre, børn og børnebørn",
		"empty": "Ingen valgt",
		"chosen": "valgt",
		"danish_crown_amount": "{amount} DKK",
		"calculate_button": "Beregn fordeling af arv",
		"read_more_will": "Læs mere om testamenter",
		"read_more_30rule": "Læs mere om 30% reglen",
		"create_will_button": "Opret Testamente - Gratis",
		"re_calculate_button": "Beregn arv",
		"heir": {
			"title": "Antal arvinger",
			"info_box": "30%-reglen er relevant for dig, der ikke har nogle direkte arvinger (forældre eller børn, børnebørn) og derfor ønsker, at fx bror, søster, nevø eller ven skal arve, da de betaler 36,25% i arveafgift.",
			"brother": "Bror",
			"sister": "Søster",
			"niece": "Niece",
			"nephew": "Nevø",
			"friend": "Ven",
			"other": "Andet"
		},
		"inheritance": {
			"title": "Arvebeløb",
			"info_box": "30%-reglen er relevant, såfremt du efterlader dig mindst 532.000 kr. og ikke har nogle direkte arvinger."
		},
		"charity": {
			"title": "Velgørenhed",
			"subtitle": "(Mulighed for at vælge flere)",
			"info_box": "De fleste velgørende foreninger er undtaget for at betale arveafgift. Oversigten i vores tabel er taget fra SKAT’s hjemmeside. Er du i tvivl, kontakt relevant forening.",
			"button": "Vælg velgørenhedsorganisation",
			"search_input": "Søg efter organisationer",
			"most_popular": "Mest populære organisationer"
		},
		"result": "Resultat",
		"sub_result": "Her kan du se hvordan 30% reglen virker",
		"result_success": "Juhuu–30%-reglen kan gøre en stor forskel for både dine arvinger og velgørenhed. Se her",
		"result_component": {
			"info_text": "Ved brug af 30%-reglen giver du 30% af din formue til velgørenhed, som fremfor dine arvinger betaler hele arveafgiften. Dine arvinger får dermed 6,25% mere i arv, og velgørenheden får de 30% minus arveafgifterne",
			"total_inhirit": "Total beløb udbetalt til arving(er)",
			"total_tax": "Samlet arveafgift",
			"without": {
				"title": "Uden brug af 30%-reglen",
				"inhirit_to": "Udbetalt arv til arving(er)"
			},
			"with": {
				"title": "Med brug af 30%-reglen",
				"inhirit_to": "Udbetalt arv til organisation(er)",
				"charity_amount_bt": "Arv til organisation(er)",
				"charity_amount_at": "Total arv til organisation(er) (efter afgifter)"
			},
			"final": "Dine arvinger får <strong class=\"color-orange\">{amount} DKK</strong> til deling (<strong class=\"color-orange\">{singleAmount} DKK</strong> mere pr. arving) ved brug af 30%-reglen.",
			"final_single": "Din arving får <strong class=\"color-orange\">{amount} DKK</strong> (<strong class=\"color-orange\">{singleAmount} DKK</strong> mere i arv) ved brug af 30%-reglen.",
			"final_charity": "Dine velgørenhedsorganisationer får <strong class='turquoise-color'>{amount} DKK</strong> til deling i arv (<strong class='turquoise-color'>{singleAmount} DKK</strong> pr. organisation).",
			"final_charity_single": "{name} får <strong class='turquoise-color'>{amount} DKK</strong> i arv.",
			"final_not_worth": {
				"title": "Med en formue på under 532.000 kr. er der desværre ingen fordel ved at bruge 30%-reglen",
				"sub_title": "Et testamente giver stadig mulighed for at støtte velgørenhed og sikre dig, at:",
				"list": {
					"1": "din sidste vijle bliver klar for alle",
					"2": "du bestemmer, hvem der arver dig",
					"3": "fordeling af arv bliver, som du har bestemt",
					"4": "bestemme særeje for arven til dine arvinger, så den ikke skal deles, hvis de en dag skal skilles",
					"5": "der er sikkerhed om, hvem der passer på dine børn, hvis du går bort, før de er fyldt 18 år"
				},
				"last": "Overbevist? Opret Testamente - det tager kun 15-30 min."
			},
			"related_products": {
				"title": "Relaterede produkter",
				"beneficiary_declaration": {
					"title": "Begunstigelseserklæring",
					"text": "Testamentet fordeler arven efter dig - bortset fra dine pensioner og forsikringer."
				},
				"future_pow": {
					"title": "Fremtidsfuldmagt",
					"text": "Bestem hvem der skal varetage dine intereresser ved sygdom/ulykke."
				},
				"content_will": {
					"title": "Indbotestamente",
					"text": "Det er ofte de små ting der har stor betydning."
				}
			}
		}
	},
	"selectPartnerModal": {
		"takeTest": {
			"title": "Vi kan hjælpe dig",
			"content": "TestaVivas Livsguide kan fortælle dig hvilke juridiske dokumenter og produkter der er relevante for dig i din nuværende livssituation, men vi har brug for at vide lidt mere om dig.<br /><br /> Tag vores test, ved at trykke på knappen herunder. Det tager kun 2 minutter.",
			"cta": "Tag testen",
			"cancel": "Jeg ønsker ikke at tage testen"
		}
	},
	"product_sidemenu": {
		"chat": "Chat",
		"call": "Ring mig op",
		"meeting": "Book møde",
		"perks": "Fordele",
		"title": "HJÆLP?"
	},
	"call_me_modal": {
		"title": "Bliv ringet op af TestaViva",
		"description": "Har du spørgsmål eller brug for hjælp? Skriv dit telefonnummer nedenfor, og vælg hvilken type rådgivning, du har brug for. Vi ringer dig op, så hurtigt vi kan.",
		"help": "Hvis du ønsker et Juridisk tjek af din(e) juridiske dokument(er), ",
		"help_link": "så tryk her.",
		"input": "Telefon nummer",
		"button": "Ring mig op",
		"phoneError": "Det indtastede telefon nummer er ikke gyldigt.",
		"reasonError": "Du mangler at vælge, hvilket emne du ønsker at snakke om.",
		"successMessage": "Du vil blive ringet op af TestaViva hurtigst muligt.",
		"errorMessage": "Det skete en fejl. Kontakt support@testaviva.dk hvis fejlen fortsætter.",
		"reason": {
			"title": "Vælg et emne",
			"legal": "Juridiske spørgsmål",
			"platform": "Spørgsmål til platformen",
			"lecture": "Ønske om foredrag",
			"other": "Andet"
		}
	},
	"bookMeeting": {
		"continue": "Fortsæt",
		"back": "Tilbage",
		"success": "Du har nu booket juridisk rådgivning med en af vores jurister, og vil blive ringet op d. {datetime}.",
		"error": "Der skete en fejl. Kontakt support@testaviva.dk hvis fejlen fortsætter.",
		"maxProduct": "Du kan vælge op til 6 produkter pr. rådgivning.<br /> Ønsker du at booke en rådgivning med flere produkter, bedes du kontakte os på 88 62 60 50.",
		"phone": {
			"invalid": "Du skal indtaste et gyldigt telefon nummer",
			"errorSave": "Der skete en fejl da vi prøvede at gemme telefonnummeret. Prøv igen, eller henvend dig til support@testaviva.dk."
		},
		"process": {
			"chooseProduct": "Vælg produkt(er)",
			"chooseTimeDate": "Vælg dato/tid",
			"choosePartners": "Vælg partnere",
			"seePriceAndConfirm": "Se priser og book"
		},
		"selectProduct": {
			"title": "Vælg hvilke produkter du ønsker at bestille rådgivning til",
			"digitalProducts": "Digitale produkter",
			"nonDigitalProducts": "Ikke-digitale produkter"
		},
		"selectDateTime": {
			"title": "Vælg hvilken dato og tidspunkt du ønsker at bestille rådgivning til"
		},
		"selectPhone": {
			"title": "Indtast det nummer vi skal ringe dig op på"
		},
		"selectPartners": {
			"title": "Vælg hvilke af vores partnere du er kunde i",
			"continueWithoutPartners": "Fortsæt uden partnere"
		},
		"confirmBooking": {
			"title": "Her er din pris",
			"totalPrice": "Den samlede pris bliver {price} DKK",
			"createBook": "Opret bruger og book",
			"loginBook": "Log ind og book",
			"book": "Book juridisk rådgivning"
		}
	},
	"newUserForm": {
		"continue": "Fortsæt",
		"buttons": {
			"accept": "Godkend",
			"decline": "Afvis",
			"create": "Opret bruger",
			"login": "Log ind på TestaViva"
		},
		"titles": {
			"name": "Indtast dit fulde navn",
			"phone": "Indtast dit telefon nummer",
			"email": "Indtast din e-mail.",
			"password": "Indtast dit kodeord",
			"confirmPassword": "Gentag dit kodeord",
			"terms": "<span>Jeg accepterer TestaVivas <a href=\"https://testaviva.dk/vilkaar\" target=\"_blank\">regler og betingelser</a></span>",
			"news": "Jeg giver samtykke til, at TestaViva kan kontakte mig pr. e-mail, SMS eller telefonisk angående fordelene ved TestaVivas juridiske dokumenter samt vejlede mig bedst muligt i denne forbindelse. Jeg er opmærksom på, at jeg til enhver tid kan trække mit samtykke tilbage på Min Profil på TestaViva.dk."
		},
		"error": {
			"emptyField": "Dette felt må ikke stå tomt.",
			"confirmPassword": "Dine kodeord er ikke ens.",
			"phone": "Dit telefon nummer er ikke gyldigt.",
			"email": "Din email er ikke gyldig.",
			"name": "Du skal indtaste dit fornavn og efternavn.",
			"terms": "Du skal acceptere vores regler og betingelser.",
			"password": "Dit kodeord skal være på min. 6 tegn og indeholde min. ét tal og ét bogstav."
		}
	},
	"perks": {
		"choose_partners": {
			"title": "Klik på de virksomheder du er kunde i eller medlem af.",
			"partners": {
				"choose": "Vælg",
				"choosen": "Valgt",
				"nobody": "Ingen",
				"nobody_text": "Jeg er <strong><i>ikke</i></strong> kunde i eller medlem af nogle af de oplistede organitationer.",
				"terms": "Jeg giver samtykke til, at TestaViva løbende må forespørge de valgte partnere om jeg er kunde eller medlem.",
				"termsError": "Du skal godkende betingelserne før du kan fortsætte.",
				"noCheckedError": "Du skal vælge en af de ovenstående valg.",
				"button": "Gem og afslut",
				"LOFagForbund": "FH-forbund"
			}
		},
		"confirmPartners": {
			"title": "Vi har registreret dine valg. <br />Er disse korrekte?",
			"bank": "Bank",
			"pension": "Pension",
			"lo": "Fagforening",
			"none": "Ingen",
			"remember_text": "*Husk at vælge alle de virksomheder du er repræsenteret hos, da dette kan sikre at du får alle dine fordele.",
			"goBackButton": "Gå tilbage og ret",
			"finishButton": "Alt er OK"
		},
		"showPerks": {
			"title": "Dine fordele som kunde/medlem af:",
			"button": "Se fordele",
			"no_partners": "Da du ikke er kunde eller medlem i nogle af virksomhederne, kan du ikke få nogle fordele.",
			"document_creation_full": "Opret testamente, ægtepagt, samejekontrakt og andre vigtige dokumenter - <strong>nemt og gratis</strong>.",
			"document_creation_partial": "Opret {text} - <strong>nemt og gratis</strong>.",
			"get_started": "Kom i gang nu"
		},
		"readPerks": {
			"saveDocuments": "Gem dine vigtige dokumenter <strong>digitalt og sikkert</strong> med NemID.",
			"lifeguide": "Få automatisk besked fra TestaViva, når dit liv har ændret sig, og dine dokumenter bør efterses og evt. opdateres."
		}
	},
	"currency": {
		"amount": "{amount} DKK",
		"valuta": " DKK",
		"thousand_separator": ".",
		"decimal_separator": ","
	},
	"document": {
		"save": {
			"exit": "Gem min kladde og afslut",
			"title": "Gem dit dokument",
			"description": "For at gemme dit dokument skal du være logget ind på TestaViva. Det er gratis, og når dit dokument er gemt,\nkan du altid vende tilbage senere og arbejde videre på dit dokument.\n",
			"userCreate": "Opret bruger og gem dokument",
			"paneCreate": "Opret bruger",
			"paneAuthenticated": "Log ind"
		}
	}
};